import compareBar from 'modules/compareBar';
import ProductPreselect from 'modules/productPreselect';

export default (function() {
	let _lastProduct;
	let _pagination;
	let _loader;
	let _request;
	let _counter;
	let _viewportHeight;
	let endIsReached;

	function init() {
		if (!window.location.href.match(/\/page\/\d/)) {
			initListeners();
			initLoader();
			$(window).on('products:reload', initLoader);
			$(window).on('products:filter', pauzeLoader);
		}
	}

	function initLoader() {
		abortRequest();

		if ($('.woocommerce-pagination').length > 0 && $('.js-single-product')) {
			_lastProduct = $('.js-single-product').last().get(0);
			_pagination = $('.woocommerce-pagination');
			$(_pagination).hide();
			_loader = $('.js-product-loader');
			_counter = $('.woocommerce-result-count');
			endIsReached = false;
			onResize();
			checkPosition();
		}
	}

	function pauzeLoader() {
		abortRequest();
		_request = true;
	}

	function abortRequest() {
		if (_request) {
			// eslint-disable-next-line no-undef
			if (_request !== true) {
				_request.abort();
			}

			_request = null;
		}
	}

	function initListeners() {
		$(window).resize(onResize);
		$(window).scroll(checkPosition);

	}

	function checkPosition() {
		if (!_request && !endIsReached && _pagination) {
			const rect = _lastProduct.getBoundingClientRect();

			// load products when reached the last 2 rows
			if (rect.top - _viewportHeight < 2 * rect.height) {
				loadNext();
			}
		}
	}

	function onResize() {
		_viewportHeight = $(window).height();
	}

	function loadNext() {
		const next = _pagination.find('a.next');
		const url  = next ? $(next).attr('href') : null;

		if (url && !_request) {
			loadResults(url);
		} else {
			endIsReached = true;
		}
	}

	function updateCounter(newCount) {
		const oldCount = $(_counter).text();
		const newCountNumber = newCount.match(/–\d*/);
		let newCountText = oldCount.replace(/–\d*/, newCountNumber);
		$(_counter).text(newCountText);
	}

	function loadResults(url, callback) {
		$(_loader).addClass('is-loading');

		_request = $.get(url)
			.done((data) => {
				const products = $(data).find('.js-single-product');
				const newPagination = $(data).find('.woocommerce-pagination').html();
				updateCounter($(data).find('.woocommerce-result-count').text());
				$(products).insertAfter(_lastProduct);
				_lastProduct = $('.js-single-product').last().get(0);
				compareBar.initCheckboxes($(products).find('.js-compare-checkbox'));
				ProductPreselect.init($(products), true);
				$(_pagination).html(newPagination);
				$(products).find('.variations_form').each(function () {
					$(this).wc_variation_form();
				});
			}).fail((jqXHR) => {
				console.log(jqXHR.responseText);

			}).always(() => {
				_request = false;
				$(_loader).removeClass('is-loading');

				if (callback) {
					callback();
				}
			});
	}
	return {init};
})();